<cer-form #form [panesDynamic]='false' [panes]="panesMasterDetail">
  <ng-template #mainTemplate>
    <cer-grid
      #mainGrid
      [viewMetadata]="viewMetadata" [dataParent]="true"
      [fieldMetadata]="fieldMetadata"
      [toolbarCommands]="toolbarCommands"
      [contextMenuCommands]="contextMenuCommands"
      [keyboardShortcuts]="keyboardShortcuts"
    ></cer-grid>
  </ng-template>
  <ng-template #rightTemplate>
    <cer-app-file-viewer-tab
      #fileViewerTab
      [enableChat]="true"
      [chats]="chats"
      [refTableId]="2"
      [refRowId]="dto?.id"
      [token]="dto?.folder"
      [attachments]="attachmentDtoList"
      [tabSelectedIndexInitial]="tabSelectedIndexInitial"
      [uploadIsActive]="false"
      (viewCommand)="onFileViewerCommand($event)"
    ></cer-app-file-viewer-tab>
  </ng-template>
</cer-form>
